































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import OdontogramPatterns from "./OdontogramPatterns.vue";
import { odontogramItems, odontogramNumbers } from "@/lib/odontogram";
import {
  renderOdontogramStatus,
  bridgeFlags,
  StatusElement
} from "@/lib/odontogram-status";
import { ToothExam, ToothExamValue, ToothSurfaceID } from "@/types/odontogram";

const BRIDGE_VALUE_IDS = new Set(["OV000094", "OV000095"]);

@Component({
  components: { OdontogramPatterns }
})
export default class Odontogram extends Vue {
  @Prop({ required: true }) encounterId!: string;
  @Prop({ default: () => [] }) toothExams!: ToothExam[];
  @Prop({ default: () => [] }) toothExamValues!: ToothExamValue[];
  @Prop({ default: false }) readonly!: boolean;

  odontogramItems = odontogramItems;
  paintValueId: string | null = null;
  eraseMode = false;

  get availableValuesAll(): ToothExamValue[] {
    return this.toothExamValues;
  }

  valueDescription(valueId: string): string {
    const v = this.toothExamValues.find((x) => x.id === valueId);
    return v ? v.display : valueId;
  }

  statusElementsFor(exam: ToothExam): StatusElement[] {
    if (BRIDGE_VALUE_IDS.has(exam.value_id)) {
      const { isBridgeStart, isBridgeEnd } = bridgeFlags(
        exam,
        this.toothExams,
        odontogramNumbers
      );
      return renderOdontogramStatus(exam, isBridgeStart, isBridgeEnd);
    }
    return renderOdontogramStatus(exam);
  }

  onSurfaceClick(toothId: number, surface: ToothSurfaceID) {
    if (this.readonly) return;

    if (this.eraseMode) {
      const next = this.toothExams.filter(
        (s) =>
          s.tooth_id !== toothId ||
          ((s.tooth_surface_id || null) !== surface &&
            (s.tooth_surface_id || null) !== null)
      );
      if (next.length !== this.toothExams.length) {
        this.$emit("input", next);
      }
      return;
    }

    if (!this.paintValueId) return;

    const value = this.toothExamValues.find((v) => v.id === this.paintValueId);
    if (!value) return;

    const targetSurface: ToothSurfaceID = value.partial ? surface : null;

    const others = this.toothExams.filter((s) => {
      if (s.tooth_id !== toothId) return true;
      const sSurface = s.tooth_surface_id || null;
      const sValue = this.toothExamValues.find((v) => v.id === s.value_id);
      const sPartial = sValue ? !!sValue.partial : sSurface !== null;
      if (value.partial) {
        return !(sPartial && sSurface === targetSurface);
      }
      return sPartial;
    });

    const added: ToothExam = {
      encounter_id: this.encounterId,
      tooth_id: toothId,
      tooth_surface_id: targetSurface,
      value_id: value.id
    };

    this.$emit("input", [...others, added]);
  }

  onReset() {
    if (this.readonly) return;
    this.$emit("input", []);
  }
}
